import React from 'react';
import { Mic, ScanLine, Bell, TrendingUp } from 'lucide-react';

const Benefits = () => {
  // Using your brand colors
  const colors = {
    primary: "#122721",
    background: "#6cf168",
    light: "#f8f9fa"
  };

  const benefits = [
    {
      // Previous SVG icon replaced with Lucide Mic icon
      // icon: (
      //   <svg viewBox="0 0 24 24" className="w-8 h-8 md:w-10 md:h-10" fill="none" stroke={colors.primary} strokeWidth="2">
      //     <path d="M12 2v6m0 0l3-3m-3 3L9 5"></path>
      //     <circle cx="12" cy="14" r="3"></circle>
      //     <path d="M5 22h14"></path>
      //     <path d="M7 22v-4.5c0-1.5 1.34-3 3-3"></path>
      //     <path d="M17 22v-4.5c0-1.5-1.34-3-3-3"></path>
      //   </svg>
      // ),
      icon: <Mic className="w-8 h-8 md:w-10 md:h-10" color={colors.primary} strokeWidth={2} />,
      // Alternative: You could also use the emoji as you suggested
      // icon: <span className="text-4xl md:text-5xl">🗣</span>,
      title: "Voice-to-Invoice",
      description: "Create invoices instantly using just your voice. Speak the details and our AI handles the rest."
    },
    {
      // Previous SVG icon replaced with Lucide ScanLine icon
      // icon: (
      //   <svg viewBox="0 0 24 24" className="w-8 h-8 md:w-10 md:h-10" fill="none" stroke={colors.primary} strokeWidth="2">
      //     <rect x="3" y="3" width="18" height="18" rx="2"></rect>
      //     <path d="M3 10h18"></path>
      //     <path d="M16 3v18"></path>
      //   </svg>
      // ),
      icon: <ScanLine className="w-8 h-8 md:w-10 md:h-10" color={colors.primary} strokeWidth={2} />,
      title: "Smart Document Scanning",
      description: "Scan invoices and receipts with your phone. Our OCR technology extracts all relevant data automatically."
    },
    {
      // Previous SVG icon replaced with Lucide Bell icon
      // icon: (
      //   <svg viewBox="0 0 24 24" className="w-8 h-8 md:w-10 md:h-10" fill="none" stroke={colors.primary} strokeWidth="2">
      //     <path d="M12 7a1 1 0 110-2 1 1 0 010 2z"></path>
      //     <path d="M12 17a1 1 0 110-2 1 1 0 010 2z"></path>
      //     <path d="M12 12a1 1 0 110-2 1 1 0 010 2z"></path>
      //     <circle cx="12" cy="12" r="10"></circle>
      //   </svg>
      // ),
      icon: <Bell className="w-8 h-8 md:w-10 md:h-10" color={colors.primary} strokeWidth={2} />,
      title: "Tax Compliance Alerts",
      description: "Stay compliant with UAE tax regulations. Get timely alerts about new laws and upcoming deadlines."
    },
    {
      // Previous SVG icon replaced with Lucide TrendingUp icon
      // icon: (
      //   <svg viewBox="0 0 24 24" className="w-8 h-8 md:w-10 md:h-10" fill="none" stroke={colors.primary} strokeWidth="2">
      //     <path d="M22 12h-4l-3 9L9 3l-3 9H2"></path>
      //   </svg>
      // ),
      icon: <TrendingUp className="w-8 h-8 md:w-10 md:h-10" color={colors.primary} strokeWidth={2} />,
      title: "Real-time Financial Insights",
      description: "Monitor your business performance with customizable dashboards and detailed financial reports."
    }
  ];

  return (
    <section id="benefits" className="py-12 md:py-16" style={{ backgroundColor: colors.light }}>
      <div className="container mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-3 md:mb-4" style={{ color: colors.primary }}>
            Why Choose Arbaah?
          </h2>
          <p className="text-base md:text-lg mx-auto max-w-3xl px-4" style={{ color: colors.primary }}>
            Our powerful features help UAE businesses streamline their finances and stay compliant
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {benefits.map((benefit, index) => (
            <div 
              key={index} 
              className="bg-white p-5 md:p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300"
            >
              <div className="mb-3 md:mb-4">
                {benefit.icon}
              </div>
              <h3 className="text-lg md:text-xl font-semibold mb-2" style={{ color: colors.primary }}>
                {benefit.title}
              </h3>
              <p className="text-sm md:text-base" style={{ color: colors.primary }}>
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Benefits;